import React from 'react'
import PropTypes from 'prop-types'

import LinearIconHelper from '../../atoms/LinearIconHelper/LinearIconHelper'
import { TextBlock } from '@aok/text-elements'
import { PrimaryButton, SecondaryButton } from '@aok/ui-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'

import Overlay from '../../atoms/Overlay/Overlay'

const DialogOverlay = ({
  icon,
  headline,
  text,
  cancelLabel,
  actionLabel,
  onAction,
  onCancel,
  onClose,
  isOpen,
  ...rest
}) => {
  return (
    <Overlay
      onClose={onClose}
      label={headline}
      isOpen={isOpen}
      windowClassName="shadow-overlay w-full max-w-750 mx-15 my-30"
      closeBtnClassName="top-5 right-5 w-48 h-48"
      closeIconClassName="w-24 h-24"
      {...rest}
    >
      <div className="bg-ffffff">
        {/* header */}
        <div
          className="relative
            flex items-center bg-f6f6f6
            min-h-60 py-20 px-10
            600:p-20
          "
        >
          {icon && (
            <LinearIconHelper
              name={icon}
              className="
                  hidden shrink-0
                  text-3DA562 fill-current
                  w-30 h-30 mr-10
                  600:block
                "
            />
          )}

          <p className="font-light text-18 leading-28 pr-40 1000:text-22">{headline}</p>
        </div>

        {/* main / text */}
        <div
          className="
              overflow-auto
              py-20 px-10
              600:p-20
            "
        >
          <TextBlock text={text} />
        </div>

        {/* footer */}
        <div
          className="footer
              flex flex-col
              px-10 py-20
              600:p-20 600:flex-row
            "
        >
          {cancelLabel && onCancel && (
            <SecondaryButton onClick={onCancel} className="min-w-245 px-20 py-10 flex-1 600:mr-5">
              {cancelLabel}
            </SecondaryButton>
          )}

          <PrimaryButton onClick={onAction} className="mt-5 min-w-245 px-20 py-10 flex-1 600:mt-0 600:ml-5">
            {actionLabel}
          </PrimaryButton>
        </div>
      </div>
    </Overlay>
  )
}

DialogOverlay.propTypes = {
  icon: PropTypes.string,
  headline: PropTypes.string,
  text: PropTypes.string,
  actionLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onAction: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
}

DialogOverlay.defaultProps = {
  headline: defaultProps.HEADLINE,
  text: defaultProps.DESCRIPTION,
  actionLabel: defaultProps.TITLE,
  onAction: () => console.warn('No onAction method set'),
  onClose: () => console.warn('No onClose method set'),
}

export default DialogOverlay
